module.exports = __webpack_public_path__ + "media/images/amenities_icons/24-c71937ae26b549f590e8292f2dc97c44.svg";